import MessageActionButtons from "./message_action_buttons.jsx";

function AiChatMessage({
  message,
  history,
  setHistory,
  toAddInTheHistory,
  setToAddInTheHistory,
  setIsStreaming,
  setCurrentQuestion,
}) {
  return (
    <div className="d-flex justify-content-start ">
      <div className="d-flex align-items-start w-100">
        <div className="bg-light rounded px-3 py-2 flex-grow-1 ">
          <div
            className="text-break"
            dangerouslySetInnerHTML={{ __html: message.answer }}
          />
          <MessageActionButtons
            answer={message}
            history={history}
            setHistory={setHistory}
            toAddInTheHistory={toAddInTheHistory}
            setToAddInTheHistory={setToAddInTheHistory}
            setIsStreaming={setIsStreaming}
            setCurrentQuestion={setCurrentQuestion}
          />
        </div>
      </div>
    </div>
  );
}

export default AiChatMessage;
